import { SwalMessage, ToastMessage, GenerateUniqueId, TaxCalculate } from '../Tools'


// Sepet v2
var ShoppingCartv2 = function () {

    // session id oluşturma
    const localSessionName = 'session_id'
    let localSessionId = localStorage.getItem(localSessionName) ? localStorage.getItem(localSessionName) : null;
    if (localSessionId == null) {
        localSessionId = GenerateUniqueId();
        localStorage.setItem(localSessionName, localSessionId);
    }


    // container
    let container = document;

    // miktar
    var quantityCountValue = 1;
    let counterElement = container.querySelector('.counter')
    let counterCountInputElement = counterElement?.querySelector('.count input')

    var loadHandle = function () {

        // mini sepet
        let items = basketProductElement.querySelectorAll('[data-product-id]');
        let itemsLength = items.length - 1;

        if (itemsLength > 0) {
            basketEmptyElement.classList.add('d-none')
            basketButtonsElement.classList.remove('d-none')
            basketElement.querySelector('[data-cart-amount]').classList.remove('d-none')
        } else {
            basketEmptyElement.classList.remove('d-none')
            basketButtonsElement.classList.add('d-none')
            basketElement.querySelector('[data-cart-amount]').classList.add('d-none')
        }

    }

    // Miktar tanımlama
    var setQuantity = function () {
        quantityCountValue = parseInt(counterCountInputElement?.value);
        quantityCountValue = (!quantityCountValue || quantityCountValue < 1 || isNaN(quantityCountValue)) ? 1 : quantityCountValue;
        if (counterCountInputElement) {
            counterCountInputElement.value = quantityCountValue;
        }
    }


    // Sepet verisi
    const GetCartFetch = async function () {
        try {
            const response = await fetch(apiUrl + '/Cart/GetFetch', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    session_id: localSessionId,
                }),
            });

            const data = await response.json();

            if (data?.row?.cart) {
                data.row.cart.forEach(function (row) {
                    MiniBasket.BasketHandle('create', row);
                    if (basketTableElement) {
                        TableBasket.BasketHandle('create', row);
                    }
                });
            }
        } catch (error) {
            console.error('Sepet Verisi Yüklenemedi. Hata:', error);
        }
    };


    // Mini sepet
    var basketElement = container.querySelector('.basket-button')
    var basketButtonElement = basketElement.querySelector('[data-basket-button]')
    var basketProductElement = container.getElementById('shopping-cart')
    var basketEmptyElement = basketElement.querySelector('[data-cart-empty]')
    var basketButtonsElement = basketElement.querySelector('[data-cart-buttons]')
    var basketItemTemplate = basketElement.querySelector('.template')
    var MiniBasket = {

        // Sepet CRUD işlemleri
        BasketHandle: function (type, cart) {
            let product = cart.product;

            if (type == 'create') {

                var productClone = basketItemTemplate.cloneNode(true);

                productClone.classList.remove('d-none')
                productClone.classList.remove('template')
                productClone.setAttribute('data-product-id', product.id)

                // ürün linki
                let slug = JSON.parse(product.slug)[langCodeLong];
                if (slug == null || slug == undefined) {
                    slug = JSON.parse(product.slug)[langCodeLongDefault];
                }
                productClone.querySelectorAll('a').forEach(function (element) {
                    element.setAttribute('href', baseUrl + '/product/' + slug);
                })


                // ürün görseli
                let picture = JSON.parse(product.thumbnail)[langCodeLong];
                if (picture == null || picture == undefined) {
                    picture = JSON.parse(product.thumbnail)[langCodeLongDefault];
                }
                productClone.querySelector('.image img').setAttribute('src', picture);

                // ürün adı
                let name = JSON.parse(product.title)[langCodeLong];
                if (name == null || name == undefined) {
                    name = JSON.parse(product.title)[langCodeLongDefault];
                }
                productClone.querySelector('.title a').innerText = name;

                // fiyat
                let price = product.sales_price
                if (product.discount) {
                    price = product.discount.discount_price
                }
                price = currencyFormat.from(price)
                productClone.querySelector('.total').innerText = currencyFormat.to(price)
                productClone.querySelector('.total').setAttribute('data-product-price', price)


                // ürün miktarı
                let amount = cart.quantity ? cart.quantity : quantityCountValue;
                productClone.querySelector('.amount').innerText = amount


                // ekle
                basketProductElement.prepend(productClone);
            }

            if (type == 'update') {

                let productItem = basketProductElement.querySelector('[data-product-id="' + product.id + '"]');

                if (productItem) {
                    // ürün miktarı
                    let amount = cart.quantity ? cart.quantity : quantityCountValue;
                    productItem.querySelector('.amount').innerText = amount
                }

            }

            if (type == 'delete') {
                let productItem = basketProductElement.querySelector('[data-product-id="' + product.id + '"]');

                if (productItem) {
                    productItem.remove();
                }
            }

            MiniBasket.BasketCalculateHandle();
        },

        // Sepete ekleme
        AddToCart: function (productId) {
            $.ajax({
                url: apiUrl + '/Cart/Add',
                type: "POST",
                dataType: "json",
                data: {
                    product_id: productId,
                    quantity: quantityCountValue,
                    session_id: localSessionId
                },
                error: function error(xhr) {
                    //console.log(xhr)
                    ToastMessage('1', translate.basket, xhr.responseJSON.text ?? xhr.responseJSON.message)

                },
                beforeSend: function () {
                    // form.querySelector('.loading').classList.remove('d-none')
                },
                complete: function () {
                    // form.querySelector('.loading').classList.add('d-none')
                    MiniBasket.BasketOpen();
                },
                success: function success(xhr) {
                    //console.log(xhr)
                    ToastMessage('0', translate.basket, xhr.text ?? xhr.message)

                    // sepet güncelle
                    MiniBasket.BasketHandle(xhr.row.type, xhr.row.cart);
                    if (basketTableElement) {
                        TableBasket.BasketHandle(xhr.row.type, xhr.row.cart);
                    }
                }
            });
        },

        // Sepetten silme
        DeleteToCart: function (productId) {
            $.ajax({
                url: apiUrl + '/Cart/Delete',
                type: "POST",
                dataType: "json",
                data: {
                    product_id: productId,
                    session_id: localSessionId
                },
                error: function error(xhr) {
                    //console.log(xhr)
                    ToastMessage('1', translate.basket, xhr.responseJSON.text ?? xhr.responseJSON.message)
                },
                beforeSend: function () {
                    // form.querySelector('.loading').classList.remove('d-none')
                },
                complete: function () {
                    // form.querySelector('.loading').classList.add('d-none')
                    MiniBasket.BasketOpen();
                },
                success: function success(xhr) {
                    //console.log(xhr)
                    ToastMessage('0', translate.basket, xhr.text ?? xhr.message)

                    // sepette göster
                    MiniBasket.BasketHandle(xhr.row.type, xhr.row.cart);
                    if (basketTableElement) {
                        TableBasket.BasketHandle(xhr.row.type, xhr.row.cart);
                    }
                }
            });
        },

        // Sepet toplamları
        BasketCalculateHandle: function () {
            let items = basketProductElement.querySelectorAll('[data-product-id]');

            let itemsLength = items.length - 1;

            if (itemsLength > 0) {
                basketEmptyElement.classList.add('d-none')
                basketButtonsElement.classList.remove('d-none')
                basketElement.querySelector('[data-cart-amount]').classList.remove('d-none')
            } else {
                basketEmptyElement.classList.remove('d-none')
                basketButtonsElement.classList.add('d-none')
                basketElement.querySelector('[data-cart-amount]').classList.add('d-none')
            }

            let cartTotal = 0;
            items.forEach(item => {
                // ürün fiyatı
                let priceElement = item.querySelector('.price .total').getAttribute('data-product-price')
                let priceValue = (!priceElement || priceElement < 0) ? 0 : priceElement;

                // console.log(priceValue);

                // ürün adeti
                let quantityElement = item.querySelector('.amount')
                var quantityValue = parseInt(quantityElement.innerText);
                quantityValue = (!quantityValue || quantityValue < 0) ? 1 : quantityValue;

                // toplam
                var itemTotal = priceValue * quantityValue;
                itemTotal = (!itemTotal || itemTotal < 0) ? 0 : itemTotal;

                cartTotal += itemTotal;

                item.querySelector('.price .total').innerText = currencyFormat.to(itemTotal)
            });


            basketElement.querySelector('[data-cart-total]').innerText = currencyFormat.to(cartTotal)

            basketElement.querySelector('[data-cart-amount]').innerText = itemsLength
        },

        // Sepeti görüntüleme
        BasketOpen: () => {
            // sepet penceresini aç
            if (!basketButtonElement.classList.contains('show')) {
                basketButtonElement.click();
            }
        },

    }


    // sepet tablosu
    var basketTableElement = container.querySelector('[data-shopping-cart-table]')
    var basketTableDiscountMinValue = 0;
    var TableBasket = {

        // Tablo CRUD işlemleri
        BasketHandle: function (type, cart) {
            let product = cart.product;

            if (type == 'create') {
                let tableItemTemplate = basketTableElement.querySelector('[data-item-template]');

                let productClone = tableItemTemplate.cloneNode(true);
                productClone.classList.remove('d-none')
                productClone.removeAttribute('data-item-template')

                productClone.setAttribute('data-product-id', product.id)
                productClone.setAttribute('data-table-element', "item")

                // ürün linki
                let slug = JSON.parse(product.slug)[langCodeLong];
                if (slug == null || slug == undefined) {
                    slug = JSON.parse(product.slug)[langCodeLongDefault];
                }
                productClone.querySelectorAll('a').forEach(function (element) {
                    element.setAttribute('href', baseUrl + '/product/' + slug);
                });

                // ürün görseli
                let picture = JSON.parse(product.thumbnail)[langCodeLong];
                if (picture == null || picture == undefined) {
                    picture = JSON.parse(product.thumbnail)[langCodeLongDefault];
                }
                productClone.querySelector('[data-element-picture] img').setAttribute('src', picture);

                // ürün adı
                let name = JSON.parse(product.title)[langCodeLong];
                if (name == null || name == undefined) {
                    name = JSON.parse(product.title)[langCodeLongDefault];
                }
                productClone.querySelector('[data-element-product] a').innerText = name;

                // ürün kodu
                let code = product.stock_code;
                productClone.querySelector('[data-element-product-code]').innerText = code;

                // fiyat
                let price = product.sales_price
                if (product.discount) {
                    price = product.discount.discount_price
                    let discountTotal = currencyFormat.from(product.sales_price) - currencyFormat.from(product.discount.discount_price)
                    productClone.querySelector('[data-element-price]')
                        .setAttribute('data-element-discount-price', currencyFormat.to(discountTotal))
                }
                price = currencyFormat.from(price)
                productClone.querySelector('[data-element-price]').innerText = currencyFormat.to(price)


                // ürün miktarı
                let amount = cart.quantity ? cart.quantity : quantityCountValue;
                productClone.querySelector('[data-element-quantity] .count input').value = amount


                basketTableElement.querySelector('tbody').prepend(productClone);
            }

            if (type == 'update') {

            }

            if (type == 'delete') {
                let productItem = basketTableElement.querySelector('[data-product-id="' + product.id + '"]');

                if (productItem) {
                    productItem.remove();
                }
            }

            TableBasket.BasketCalculateHandle();
        },

        // Tablo güncelleme
        UpdateToCart: function (productId, quantity) {
            $.ajax({
                url: apiUrl + '/Cart/Update',
                type: "POST",
                dataType: "json",
                data: {
                    product_id: productId,
                    quantity: quantity,
                    session_id: localSessionId
                },
                error: function error(xhr) {
                    //console.log(xhr)
                    ToastMessage('1', translate.basket, xhr.responseJSON.text ?? xhr.responseJSON.message)
                },
                beforeSend: function () {
                    // form.querySelector('.loading').classList.remove('d-none')
                },
                complete: function () {
                    // form.querySelector('.loading').classList.add('d-none')
                },
                success: function success(xhr) {
                    //console.log(xhr)
                    ToastMessage('0', translate.basket, xhr.text ?? xhr.message)

                    // sepet güncelle
                    MiniBasket.BasketHandle(xhr.row.type, xhr.row.cart);
                    TableBasket.BasketHandle(xhr.row.type, xhr.row.cart);
                }
            });
        },

        // Tablodan silme
        DeleteToCart: function (productId) {
            $.ajax({
                url: apiUrl + '/Cart/Delete',
                type: "POST",
                dataType: "json",
                data: {
                    product_id: productId,
                    session_id: localSessionId
                },
                error: function error(xhr) {
                    //console.log(xhr)
                    ToastMessage('1', translate.basket, xhr.responseJSON.text ?? xhr.responseJSON.message)
                },
                beforeSend: function () {
                    // form.querySelector('.loading').classList.remove('d-none')
                },
                complete: function () {
                    // form.querySelector('.loading').classList.add('d-none')
                },
                success: function success(xhr) {
                    //console.log(xhr)
                    ToastMessage('0', translate.basket, xhr.text ?? xhr.message)

                    // sepet güncelle
                    MiniBasket.BasketHandle(xhr.row.type, xhr.row.cart);
                    TableBasket.BasketHandle(xhr.row.type, xhr.row.cart);
                }
            });
        },

        // Tablo toplamları
        BasketCalculateHandle: function () {
            var items = [].slice.call(basketTableElement.querySelectorAll('tbody [data-table-element="item"]'));

            var subTotal = 0;

            items.map(function (item) {

                // miktar
                var quantityElement = item.querySelector('[data-element-quantity] .count input')
                var quantityValue = parseInt(quantityElement.value);
                quantityValue = (!quantityValue || quantityValue < 0) ? 1 : quantityValue;

                // ürün fiyatı
                var priceElement = item.querySelector('[data-element-price]')
                var priceValue = (!priceElement.innerText || priceElement.innerText < 0) ? 0 : currencyFormat.from(priceElement.innerText);
                priceValue = (!priceValue || priceValue < 0) ? 0 : priceValue;

                var itemTotal = priceValue * quantityValue;
                itemTotal = (!itemTotal || itemTotal < 0) ? 0 : itemTotal;
                item.querySelector('[data-element-total]').innerText = currencyFormat.to(itemTotal);

                subTotal += itemTotal
            });

            // kargo limiti ve ücreti
            var cargoTotalElement = basketTableElement.querySelector('[data-element-cargo]')
            var cargoValue = (!cargoTotalElement.getAttribute('data-value') || cargoTotalElement.getAttribute('data-value') < 0) ? 0 : currencyFormat.from(cargoTotalElement.getAttribute('data-value'));

            if (subTotal >= cartShippingLimit) {
                cargoValue = 0;
                cargoTotalElement.innerText = currencyFormat.to(cargoValue);
            } else {

                // adrese göre kargo ücreti varsa yansıtma
                let cargoFee = ShippingAddressCargoFee()?.responseJSON;
                if (cargoFee?.amount) {
                    cargoValue = currencyFormat.from(cargoFee.amount);
                }

                // toplamlara yansıt
                cargoTotalElement.innerText = currencyFormat.to(cargoValue);
                subTotal += cargoValue;
            }

            // indirim hesaplama
            if (subTotal < basketTableDiscountMinValue) {
                const buttonCoupon = container.querySelector('[data-order-coupon-submit]')
                const buttonCouponRemove = container.querySelector('[data-order-coupon-remove-submit]')

                buttonCoupon.removeAttribute('disabled');
                buttonCoupon.classList.remove('d-none')
                buttonCouponRemove.classList.add('d-none')
                container.querySelector('[name="coupon_id"]').value = ''
                container.querySelector('[data-element-coupontotal]').innerText = currencyFormat.to(0)
            } else {
                var couponTotalElement = basketTableElement.querySelector('[data-element-coupontotal]')
                var couponValue = (!couponTotalElement.innerText || couponTotalElement.innerText < 0) ? 0 : currencyFormat.from(couponTotalElement.innerText);
                if (couponValue > 0) {
                    subTotal -= couponValue;
                }
            }

            // KDV DAHİL HESAPLAMA - INCLUDING
            if (taxType == 'Including') {

                // vergi toplam
                var taxTotalElement = basketTableElement.querySelector('[data-element-taxtotal]')
                var taxTotalValue = TaxCalculate(subTotal);
                taxTotalValue = (!taxTotalValue || taxTotalValue < 0) ? 0 : taxTotalValue;
                taxTotalElement.innerText = currencyFormat.to(taxTotalValue)


                // ara toplam
                var subTotalElement = basketTableElement.querySelector('[data-element-subtotal]')
                var subTotalValue = (!subTotal || subTotal < 0) ? 0 : subTotal;
                subTotalElement.innerText = currencyFormat.to(subTotalValue - taxTotalValue);

                // toplam
                var grandTotalElement = basketTableElement.querySelector('[data-element-grandtotal]')
                grandTotalElement.innerText = currencyFormat.to(subTotalValue)
            }

            // KDV HARİÇ HESAPLAMA - NORMAL
            else if (taxType == 'Normal') {
                // ara toplam
                var subTotalElement = basketTableElement.querySelector('[data-element-subtotal]')
                var subTotalValue = (!subTotal || subTotal < 0) ? 0 : subTotal;
                subTotalElement.innerText = currencyFormat.to(subTotalValue);

                // vergi toplam - kdv hariç hesaplama
                var taxTotalElement = basketTableElement.querySelector('[data-element-taxtotal]')
                var taxTotalValue = TaxCalculate(subTotalValue);
                taxTotalValue = (!taxTotalValue || taxTotalValue < 0) ? 0 : taxTotalValue;
                taxTotalElement.innerText = currencyFormat.to(taxTotalValue)


                // toplam
                var grandTotalElement = basketTableElement.querySelector('[data-element-grandtotal]')
                grandTotalElement.innerText = currencyFormat.to(subTotalValue + taxTotalValue)

            }


        },

    }

    // Aksiyon işlemleri
    var Actions = function () {

        // Sepete ekle butonu
        $(container).on('click', '[data-shopping-cart="add"]', function (event) {
            event.preventDefault();

            setQuantity();

            let productId = this.getAttribute('data-product-id');
            MiniBasket.AddToCart(productId);
        })

        // Satın al butonu
        $(container).on('click', '[data-shopping-buy="add"]', function (event) {
            event.preventDefault();

            setQuantity();

            let productId = this.getAttribute('data-product-id');
            MiniBasket.AddToCart(productId);

            location.href = "/checkout"
        })

        // Sepetten ürün silme
        $(basketElement).on('click', '[data-product-remove]', function (event) {
            event.preventDefault();

            setQuantity();

            let productId = event.target.closest('.product').getAttribute('data-product-id')
            MiniBasket.DeleteToCart(productId);
        })

        // Tablodan ürün silme
        $(basketTableElement).on('click', '[data-element-remove]', function (event) {
            event.preventDefault();

            let productId = event.target.closest('tr').getAttribute('data-product-id')
            TableBasket.DeleteToCart(productId);
        })

        // Tablo miktar düşürme
        $(basketTableElement).on('click', '[data-counter="minus"]', function (event) {
            event.preventDefault();

            let element = event.target.closest('tr');

            var input = element.querySelector('.count input')

            var count = parseInt(input.value);
            if (!count || count <= 0 || isNaN(count)) {
                input.value = 1;
            } else {
                input.value = (count > 1) ? count - 1 : input.value
            }

            let minusButton = element.querySelector('[data-counter="minus"]');
            if (input.value <= 1) {
                minusButton.setAttribute('disabled')
            } else {
                minusButton.removeAttribute('disabled')
            }

            var productId = element.getAttribute('data-product-id')
            var amount = input.value

            TableBasket.UpdateToCart(productId, amount);
        })

        // Tablo miktar arttırma
        $(basketTableElement).on('click', '[data-counter="plus"]', function (event) {
            event.preventDefault();

            let element = event.target.closest('tr');

            var input = element.querySelector('.count input')


            var count = parseInt(input.value);
            if (count + 1 > parseInt(input.getAttribute('max'))) {
                input.value = input.getAttribute('max')
                this.setAttribute('disabled', 'true')
                return;
            }
            input.value = (count > 0) ? count + 1 : input.value

            let minusButton = element.querySelector('[data-counter="minus"]');
            if (input.value >= 1) {
                minusButton.removeAttribute('disabled')
            } else {
                minusButton.setAttribute('disabled')
            }

            var productId = element.getAttribute('data-product-id')
            var amount = input.value

            TableBasket.UpdateToCart(productId, amount);
        })


        // Teslimat adresi değiştiğinde tablo güncelle
        $(container).on('change', '[data-form-select="shipping"]', function (event) {
            event.preventDefault();
            TableBasket.BasketCalculateHandle();
        })

    }

    // Teslimat metodu değişince sepet hesaplama
    var ShippingObServer = function () {
        const cargoElement = document.querySelector("[data-element-cargo]");

        if (cargoElement) {

            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-value') {
                        TableBasket.BasketCalculateHandle();
                    }
                }
            });
            if (cargoElement) {
                observer.observe(cargoElement, { attributes: true });
            }
        }
    }

    // teslimat adresine göre kargo ücreti yansıtma
    var ShippingAddressCargoFee = function () {
        const shippingElement = container.querySelector('[data-form-select="shipping"]');

        if(!shippingElement){
            return;
        }

        let shippingAddres = shippingElement.options[shippingElement.selectedIndex]?.getAttribute('data-address');

        let jsonData = JSON.parse(shippingAddres);

        return $.ajax({
            url: apiUrl + '/AdressByCargoFee',
            type: 'POST',
            contentType: 'application/json',
            async: false,
            data: JSON.stringify({
                address: jsonData,
            }),
            success: function (data) {
                // console.log(data);
                return data.responseJSON;
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error('Hata:', errorThrown);
            },
            complete: function () {
            }
        });


    }

    // Kupon işlemleri
    var CouponHandle = function () {
        const buttonCoupon = container.querySelector('[data-order-coupon-submit]');
        const buttonCouponRemove = container.querySelector('[data-order-coupon-remove-submit]');
        const couponCodeInput = container.querySelector('[name="coupon_code"]');
        const couponIdInput = container.querySelector('[name="coupon_id"]');
        const couponTotalElement = container.querySelector('[data-element-coupontotal]');

        // kupon uygula butonu
        $(container).on('click', '[data-order-coupon-submit]', function (event) {
            event.preventDefault();

            let couponCode = couponCodeInput.value;
            let button = this;

            let products = [];

            let productItems = basketTableElement.querySelectorAll('tbody [data-table-element="item"]');

            productItems.forEach(function (item) {
                console.log(item);
                let productId = item.getAttribute('data-product-id');
                let productName = item.querySelector('[data-element-product]')?.innerText;

                products.push({
                    id: productId,
                    name: productName
                });
            });

            $.ajax({
                url: apiUrl + '/UserCouponCheck',
                type: "POST",
                dataType: "json",
                data: {
                    code: couponCode,
                    userId: container.querySelector('[data-user-id]').getAttribute('data-user-id'),
                    products: products
                },
                async: true,
                error: function (xhr) {
                    // console.log('error', xhr);
                    handleCouponError(xhr, button);
                },
                beforeSend: function () {
                    button.setAttribute('disabled', '');
                    buttonCouponRemove.classList.add('d-none');
                },
                complete: function () {
                    // ...
                },
                success: function (response) {
                    // console.log('success', response);
                    handleCouponSuccess(response, button);
                }
            });
        });

        // kupon kaldır butonu
        $(container).on('click', '[data-order-coupon-remove-submit]', function (event) {
            resetCoupon();
        });

        // hatalı işlem
        function handleCouponError(xhr, button) {
            SwalMessage(
                {
                    type: 'error',
                    text: xhr.responseJSON.text ?? xhr.responseJSON.message,
                    confirmButton: translate.ok_button,
                },
                function () {
                    // location.reload();
                }
            );
            button.removeAttribute('disabled');
            buttonCouponRemove.classList.add('d-none');
            resetCoupon();
        }

        // başarılı işlem
        function handleCouponSuccess(response, button) {
            button.classList.add('d-none');
            couponIdInput.value = response.row.id;

            if (response.row.coupon_type === 'constant') {
                handleConstantCoupon(response, button);
            } else if (response.row.coupon_type === 'percent') {
                handlePercentCoupon(response, button);
            }
        }

        // sabit kupon türü
        function handleConstantCoupon(response, button) {
            let amount = response.row.constant_amount;
            let amountValue = currencyFormat.from(amount);
            amountValue = (!amountValue || amountValue < 0) ? 0 : amountValue;

            couponTotalElement.innerText = currencyFormat.to(amountValue);

            TableBasket.BasketCalculateHandle();

            SwalMessage(
                {
                    type: 'success',
                    text: response.text || response.message,
                    confirmButton: translate.ok_button,
                },
                function () {
                    button.removeAttribute('disabled');
                    buttonCouponRemove.classList.remove('d-none');
                }
            );
        }

        // yüzdeli kupon türü
        function handlePercentCoupon(response, button) {
            var grandTotalElement = container.querySelector('[data-element-grandtotal]');
            var grandTotalValue = currencyFormat.from(grandTotalElement.innerText);

            var minAmount = response.row.percent_min_amount;
            let minAmountValue = currencyFormat.from(minAmount);
            minAmountValue = (!minAmountValue || minAmountValue < 0) ? 0 : minAmountValue;

            basketTableDiscountMinValue = minAmountValue;

            if (grandTotalValue < minAmountValue) {
                TableBasket.BasketCalculateHandle();
                SwalMessage(
                    {
                        type: 'error',
                        text: translate.coupon_limit,
                        confirmButton: translate.ok_button,
                    },
                    function () {
                        button.removeAttribute('disabled');
                        button.classList.remove('d-none');
                        buttonCouponRemove.classList.add('d-none');
                        resetCoupon();
                    }
                );
                return;
            }

            var percentRate = parseInt(response.row.percent_rate);
            var discountTotal = (grandTotalValue * percentRate) / 100;
            couponTotalElement.innerText = currencyFormat.to(discountTotal);

            TableBasket.BasketCalculateHandle();

            SwalMessage(
                {
                    type: 'success',
                    text: response.text || response.message,
                    confirmButton: translate.ok_button,
                },
                function () {
                    button.removeAttribute('disabled');
                    buttonCouponRemove.classList.remove('d-none');
                }
            );
        }

        // kupon sıfırlama
        function resetCoupon() {
            buttonCouponRemove.classList.add('d-none');
            buttonCoupon.classList.remove('d-none');
            couponCodeInput.value = '';
            couponIdInput.value = '';
            couponTotalElement.innerText = currencyFormat.to(0);
            TableBasket.BasketCalculateHandle();
        }
    };


    return {
        init: async function () {
            loadHandle();
            setQuantity();
            await GetCartFetch();
            Actions();
            CouponHandle();
            ShippingObServer();
        },
    };

}();


$(function () {
    ShoppingCartv2.init();
});